import { render, staticRenderFns } from "./BaseImageFileInput.vue?vue&type=template&id=5c9473a7&scoped=true&"
import script from "./BaseImageFileInput.vue?vue&type=script&lang=js&"
export * from "./BaseImageFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9473a7",
  null
  
)

export default component.exports